import { Button, Modal } from '@hakimo-ui/shared/ui-base';
import { Portal } from '@headlessui/react';
import { VideoCameraIcon } from '@heroicons/react/24/outline';
import { ExclamationTriangleIcon } from '@heroicons/react/24/solid';
import { MutableRefObject } from 'react';
import { MAX_SELECTED_CAMERAS } from './util';

interface Props {
  open: boolean;
  onClose: () => void;
  portalTarget?: MutableRefObject<HTMLElement | null>;
}

export function CameraLimitModal(props: Props) {
  const { open, onClose, portalTarget } = props;

  const content = (
    <Modal open={open} onClose={onClose} closable={false}>
      <div className="w-96 px-8 py-6">
        <div className="bg-status-orange/10 mx-auto flex h-16 w-16 items-center justify-center rounded-full">
          <ExclamationTriangleIcon className="text-status-orange h-8 w-8" />
        </div>
        <h1 className="text-onlight-text-1 dark:text-ondark-text-1 mt-4 text-center text-lg font-medium">
          Camera View Limit Reached
        </h1>
        <p className="text-onlight-text-2 dark:text-ondark-text-2 mt-1 text-center text-sm">
          You can view a maximum of {MAX_SELECTED_CAMERAS} cameras at a time.
        </p>
        <div className="border-onlight-line-2 dark:border-ondark-line-2 mt-5 flex items-center gap-3 rounded-lg border p-3">
          <div className="bg-primary-800/10 flex h-9 w-9 flex-none items-center justify-center rounded-lg">
            <VideoCameraIcon className="text-primary-800 dark:text-primary-500 h-5 w-5" />
          </div>
          <div>
            <p className="text-onlight-text-1 dark:text-ondark-text-1 text-sm">
              {MAX_SELECTED_CAMERAS} cameras are already selected.
            </p>
          </div>
        </div>
        <div className="mt-6">
          <Button variant="primary" onClick={onClose} block autoFocus>
            Got it
          </Button>
        </div>
      </div>
    </Modal>
  );

  if (!portalTarget) {
    return content;
  }
  return <Portal.Group target={portalTarget}>{content}</Portal.Group>;
}

export default CameraLimitModal;
